export * from './BeautyCosmeticsPerfumeIcon';
export * from './BeautyCosmeticsPerfumeIcon16Light';
export * from './BeautyCosmeticsPerfumeIcon16Regular';
export * from './BeautyCosmeticsPerfumeIcon16Solid';
export * from './BeautyCosmeticsPerfumeIcon20Light';
export * from './BeautyCosmeticsPerfumeIcon20Regular';
export * from './BeautyCosmeticsPerfumeIcon20Solid';
export * from './BeautyCosmeticsPerfumeIcon24Regular';
export * from './BeautyCosmeticsPerfumeIcon24Solid';
export * from './BeautyCosmeticsPerfumeIcon32Regular';
export * from './BeautyCosmeticsPerfumeIcon64Regular';
